// src/authProvider.js

import { API_URL } from './config'; // <-- **الإضافة الجديدة**: استيراد الرابط المركزي

const authProvider = {
    login: ({ username, password }) =>  {
        const request = new Request(`${API_URL}/auth/login`, { // <-- **التعديل**: استخدام API_URL
            method: 'POST',
           body: JSON.stringify({ 
                identifier: username, // <-- **التعديل**: تغيير "email" إلى "identifier"
                password, 
                source: 'admin' // This key is important for the backend to identify admin logins
            }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    // Try to get a specific error message from the backend response body
                    return response.json().then(error => {
                        throw new Error(error.error || response.statusText);
                    });
                }
                return response.json();
            })
            .then(auth => {
                // Store the token and user info in localStorage
                localStorage.setItem('token', auth.token);
                if (auth.user) {
                    localStorage.setItem('user', JSON.stringify(auth.user));
                }
            })
            .catch((err) => {
                // Throw a more user-friendly error
                throw new Error(err.message || 'Invalid email or password');
            });
    },

    /**
     * Called when the user clicks the logout button.
     */
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        return Promise.resolve();
    },

    /**
     * Called when the API returns an error.
     */
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            return Promise.reject(); // This will redirect to the login page
        }
        // Do not redirect for other errors
        return Promise.resolve();
    },

    /**
     * Called when the user navigates to a new location, to check for authentication.
     */
    checkAuth: () =>
        localStorage.getItem('token') ? Promise.resolve() : Promise.reject(),

    /**
     * Called when the user navigates to a new location, to check for permissions.
     * We don't have a roles/permissions system in this admin panel, so we resolve.
     */
    getPermissions: () => Promise.resolve(),
};

export default authProvider;